import {
  EventEmitter,
  Directive,
  Output,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { ImageViewerProvider } from '../../providers/image-viewer/image-viewer';

/**
 * Generated class for the ImageViewerDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[image-viewer]', // Attribute selector
})
export class ImageViewerDirective {
  @Output() opened = new EventEmitter();

  constructor(
    public element: ElementRef,
    public imgViewer: ImageViewerProvider
  ) {
    element.nativeElement.addEventListener('click', () => {
      if (element.nativeElement.src) {
        imgViewer.open(element.nativeElement.src);
        this.opened.emit();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/directives/image-viewer/image-viewer.ts